/* NUSA · LIVING DESIGN — interacciones del tema (sin dependencias). */
(function () {
  "use strict";

  /* ---------- Preloader ---------- */
  function initLoader() {
    var el = document.getElementById("nusa-loader");
    if (!el) return;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.classList.add("done");
    }
    setTimeout(finish, 1400);
    setTimeout(finish, 4000);
    if (document.readyState === "complete") {
      setTimeout(finish, 400);
    } else {
      window.addEventListener("load", finish);
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    function observeNew() {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) { io.observe(el); });
    }
    observeNew();
    var mo = new MutationObserver(observeNew);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Header: solid on scroll + mobile menu + catalog dropdown ---------- */
  function initHeader() {
    var header = document.querySelector(".nusa-header");
    if (!header) return;
    var hasHero = header.dataset.hasHero === "true";
    var burger = header.querySelector(".nusa-burger");
    var mobileNav = header.querySelector(".nusa-mobile-nav");
    var catalog = header.querySelector(".nusa-catalog");
    var menuOpen = false;

    function applySolid() {
      var solid = window.scrollY > 60 || menuOpen || !hasHero;
      header.classList.toggle("is-solid", solid);
    }
    applySolid();
    window.addEventListener("scroll", applySolid, { passive: true });

    if (burger && mobileNav) {
      burger.addEventListener("click", function () {
        menuOpen = !menuOpen;
        burger.classList.toggle("is-open", menuOpen);
        mobileNav.classList.toggle("is-open", menuOpen);
        applySolid();
      });
    }

    if (catalog) {
      var closeTimer = null;
      var panel = catalog.querySelector(".nusa-catalog__panel");
      catalog.addEventListener("mouseenter", function () {
        if (closeTimer) clearTimeout(closeTimer);
        catalog.classList.add("is-open");
      });
      catalog.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(function () { catalog.classList.remove("is-open"); }, 140);
      });
      if (panel) {
        panel.addEventListener("click", function (e) {
          var link = e.target.closest("a");
          if (link) catalog.classList.remove("is-open");
        });
      }
    }
  }

  /* ---------- Carrusel horizontal con snap + flechas + autoplay ---------- */
  function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

  function animateScrollTo(el, target, duration) {
    var start = el.scrollLeft;
    var distance = target - start;
    if (Math.abs(distance) < 1) return;
    var originalSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = "none";
    var startTime = null;
    var token = (el._nusaScrollToken = (el._nusaScrollToken || 0) + 1);

    function step(now) {
      if (el._nusaScrollToken !== token) return;
      if (startTime === null) startTime = now;
      var t = Math.min((now - startTime) / duration, 1);
      el.scrollLeft = start + distance * easeOutQuint(t);
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.scrollSnapType = originalSnap;
      }
    }
    requestAnimationFrame(step);
  }

  function initCarousels() {
    document.querySelectorAll("[data-nusa-carousel]").forEach(function (root) {
      var scroller = root.querySelector("[data-scroller]");
      if (!scroller) return;
      var autoplayMs = Number(root.dataset.autoplay || 0);
      var duration = 1100;
      var paused = false;
      var resumeTimer = null;

      function cardStep() {
        var card = scroller.querySelector("[data-card]");
        return (card ? card.offsetWidth : 360) + 16;
      }
      function advance(dir) {
        var step = cardStep();
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var target = scroller.scrollLeft + dir * step;
        if (target >= maxScroll - 4) target = maxScroll;
        if (target < 4) target = 0;
        if (dir === 1 && scroller.scrollLeft >= maxScroll - 4) target = 0;
        animateScrollTo(scroller, target, duration);
      }
      function pauseThenResume(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, ms || 5000);
      }

      root.querySelectorAll("[data-dir]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          advance(Number(btn.dataset.dir));
          pauseThenResume();
        });
      });
      scroller.addEventListener("mouseenter", function () { paused = true; });
      scroller.addEventListener("mouseleave", function () { paused = false; });
      scroller.addEventListener("touchstart", function () { paused = true; }, { passive: true });
      scroller.addEventListener("touchend", function () { pauseThenResume(); });

      if (autoplayMs > 0 && root.children.length && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setInterval(function () { if (!paused) advance(1); }, autoplayMs);
      }
    });
  }

  /* ---------- Filtro de catálogo (buscar por nombre + se está agotando) ---------- */
  function initCatalogFilter() {
    var grid = document.querySelector("[data-catalog-grid]");
    if (!grid) return;
    var input = document.querySelector("[data-catalog-search]");
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-product-card]"));
    var emptyMsg = document.querySelector("[data-catalog-empty]");
    var params = new URLSearchParams(window.location.search);
    var lowStockOnly = params.get("agotando") === "1";

    function normalize(s) {
      return (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");
    }

    function apply() {
      var q = normalize(input ? input.value : "");
      var visible = 0;
      cards.forEach(function (card) {
        var name = normalize(card.dataset.name);
        var isLow = card.dataset.lowstock === "true";
        var show = (!q || name.indexOf(q) !== -1) && (!lowStockOnly || isLow);
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (emptyMsg) emptyMsg.style.display = (cards.length > 0 && visible === 0) ? "" : "none";
    }

    if (input) {
      var t;
      input.addEventListener("input", function () {
        clearTimeout(t);
        t = setTimeout(apply, 200);
      });
    }
    apply();
  }

  /* ---------- Filtro de blog por categoria (?tag=) ---------- */
  function initBlogFilter() {
    var grid = document.querySelector("[data-blog-grid]");
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-post-card]"));
    var emptyMsg = document.querySelector("[data-blog-empty]");
    var chips = document.querySelectorAll("[data-blog-filters] [data-tag]");
    var activeTag = new URLSearchParams(window.location.search).get("tag") || "";

    var visible = 0;
    cards.forEach(function (card) {
      var tags = (card.dataset.tags || "").split(",");
      var show = !activeTag || tags.indexOf(activeTag) !== -1;
      card.style.display = show ? "" : "none";
      if (show) visible++;
    });
    if (emptyMsg) emptyMsg.style.display = visible === 0 ? "" : "none";

    chips.forEach(function (chip) {
      chip.classList.toggle("is-active", chip.dataset.tag === activeTag);
    });
  }

  /* ---------- Selector de variantes por swatch (foto + color) en ficha de producto ---------- */
  function initVariantPicker() {
    var picker = document.querySelector("[data-variant-picker]");
    if (!picker) return;
    var swatches = Array.prototype.slice.call(picker.querySelectorAll("[data-swatch]"));
    if (!swatches.length) return;
    var idInput = document.querySelector("[data-variant-id-input]");
    var priceEl = document.querySelector("[data-variant-price]");
    var btn = document.querySelector("[data-add-to-cart-btn]");
    var btnLabel = document.querySelector("[data-add-to-cart-label]");
    var selectedLabel = document.querySelector("[data-swatch-selected-label]");
    var mainImg = document.getElementById("nusa-gallery-main-img");

    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        swatches.forEach(function (s) { s.classList.remove("is-active"); });
        sw.classList.add("is-active");

        if (idInput) idInput.value = sw.dataset.variantId;
        if (selectedLabel) selectedLabel.textContent = sw.dataset.variantLabel;

        if (priceEl) {
          if (sw.dataset.priceZero === "true") {
            priceEl.textContent = "Consultar";
          } else if (sw.dataset.compareAtFormatted) {
            priceEl.innerHTML = "<s>" + sw.dataset.compareAtFormatted + "</s>" + sw.dataset.priceFormatted;
          } else {
            priceEl.textContent = sw.dataset.priceFormatted;
          }
        }

        var available = sw.dataset.available === "true";
        var onRequest = sw.dataset.priceZero === "true";
        if (btn) btn.disabled = !available || onRequest;
        if (btnLabel) btnLabel.textContent = onRequest ? "Consultar precio" : (available ? "Añadir al carrito" : "Agotado");

        if (mainImg && sw.dataset.image) mainImg.src = sw.dataset.image;
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.dataset.full || thumb.querySelector("img").src;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- Medición: whatsapp_click, quote_submit, showroom_directions_click ----------
     Solo empuja a window.dataLayer (convención de Google Tag Manager). Si el sitio no tiene
     GTM/GA4 conectado (Configuración > Motores de búsqueda y aplicaciones > Google & YouTube,
     o un pixel personalizado en Configuración > Eventos de clientes), esto no hace nada visible
     todavía, pero queda listo para funcionar en cuanto se conecte. No se envía ningún dato
     personal (nombre, email, teléfono) — solo el nombre del evento y contexto genérico
     (de dónde vino el clic, qué producto se estaba viendo). */
  function trackEvent(eventName, extra) {
    if (!window.dataLayer || typeof window.dataLayer.push !== "function") return;
    var payload = { event: eventName };
    if (extra) {
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key) && extra[key]) payload[key] = extra[key];
      }
    }
    window.dataLayer.push(payload);
  }

  function initAnalyticsTracking() {
    document.querySelectorAll("[data-track-on-load]").forEach(function (el) {
      trackEvent(el.dataset.trackOnLoad);
    });
    document.querySelectorAll("[data-track]").forEach(function (el) {
      el.addEventListener("click", function () {
        trackEvent(el.dataset.track, {
          source: el.dataset.trackSource,
          product: el.dataset.trackProduct
        });
      });
    });
  }

  /* ---------- Carrito: stepper de cantidad (+/-) ---------- */
  function initCartQtyStepper() {
    var steppers = document.querySelectorAll("[data-qty-stepper]");
    if (!steppers.length) return;
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector("[data-qty-input]");
      var dec = stepper.querySelector("[data-qty-decrease]");
      var inc = stepper.querySelector("[data-qty-increase]");
      function submitUpdate() {
        var form = input.closest("form");
        var updateBtn = form && form.querySelector('button[name="update"]');
        if (form && updateBtn) form.requestSubmit(updateBtn);
      }
      dec.addEventListener("click", function () {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        submitUpdate();
      });
      inc.addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        submitUpdate();
      });
    });
  }

  /* ---------- Formulario de contacto nativo de Shopify: feedback simple ---------- */
  function initContactForm() {
    var form = document.getElementById("ContactForm");
    if (!form) return;
    form.addEventListener("submit", function () {
      var btn = form.querySelector("button[type='submit']");
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.pendingLabel || "Enviando…";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLoader();
    initReveal();
    initHeader();
    initCarousels();
    initCatalogFilter();
    initBlogFilter();
    initVariantPicker();
    initProductGallery();
    initCartQtyStepper();
    initContactForm();
    initAnalyticsTracking();
  });
})();
